export enum CustomerBusinessType {
  SOLE_TRADER = 'sole-trader',
  COMPANY = 'company'
}